if (!window.RitualPremiumCartReady) {
  window.RitualPremiumCartReady = true;

  const root = () => window.Shopify?.routes?.root || '/';

  const updateVariant = (select) => {
    const card = select.closest('[data-rpc-card]');
    const option = select.selectedOptions?.[0];
    if (!card || !option) return;

    const price = card.querySelector('[data-rpc-price]');
    if (price) price.textContent = option.dataset.price || '';

    const compare = card.querySelector('[data-rpc-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    const image = card.querySelector('[data-rpc-image]');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = option.dataset.image;
    }
  };

  const refreshBubble = async () => {
    const cart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
    document.querySelectorAll('[data-testid="cart-bubble"]').forEach((bubble) => {
      bubble.textContent = cart.item_count;
      bubble.classList.toggle('hidden', cart.item_count === 0);
      bubble.closest('.cart-bubble')?.classList.toggle('visually-hidden', cart.item_count === 0);
    });
  };

  const addUpsell = async (button) => {
    const card = button.closest('[data-rpc-card]');
    const select = card?.querySelector('[data-rpc-select]');
    if (!card || !select?.value || button.disabled) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: select.value, quantity: 1 }] })
      });
      if (!response.ok) throw new Error(await response.text());

      await response.json();
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', 'cart-drawer-section');
      sectionUrl.searchParams.set('_', Date.now().toString());
      const html = await fetch(sectionUrl.toString(), { cache: 'no-store', headers: { Accept: 'text/html' } }).then((sectionResponse) => {
        if (!sectionResponse.ok) throw new Error('Cart drawer refresh failed');
        return sectionResponse.text();
      });

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('#shopify-section-cart-drawer-section');
      const current = document.querySelector('#shopify-section-cart-drawer-section');
      if (!fresh || !current) throw new Error('Cart drawer section could not be refreshed');

      const currentDrawer = current.querySelector('#cart-drawer');
      const freshDrawer = fresh.querySelector('#cart-drawer');
      if (!currentDrawer || !freshDrawer) throw new Error('Cart drawer content could not be refreshed');

      currentDrawer.replaceWith(freshDrawer);
      await refreshBubble();
      await customElements.whenDefined('theme-drawer');
      requestAnimationFrame(() => document.querySelector('#cart-drawer')?.open());
    } catch (error) {
      console.error('[Ritual cart upsell]', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-rpc-select]');
    if (select?.matches('select')) updateVariant(select);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-rpc-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addUpsell(button);
  });
}
